import type { FC, ReactNode } from "react";

type RadioButtonProps = {
  checked: boolean;
  onChange: () => void;
  label: ReactNode;
  name: string;
  value: string | number;
  disabled?: boolean;
};

export const RadioButton: FC<RadioButtonProps> = ({
  checked,
  onChange,
  label,
  name,
  value,
  disabled,
}) => (
  <label
    className={`flex cursor-pointer items-center space-x-2 ${disabled ? "opacity-50" : ""}`}
  >
    <span className="relative flex items-center">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="sr-only"
        disabled={disabled}
      />
      <span
        className={`flex h-5 w-5 items-center justify-center rounded-full transition-colors ${
          checked ? "border-2 border-primary bg-primary" : "bg-[#E1E9F0]"
        }`}
      >
        {checked && (
          <span className="block h-2.5 w-2.5 rounded-full bg-white" />
        )}
      </span>
    </span>
    <span className="font-ambit text-[0.9375rem] not-italic font-normal leading-[1.25rem] text-secondary">
      {label}
    </span>
  </label>
);
